import React, { memo } from 'react';
import { IconAsChunk } from '@boschebike/ebds-react-icons';
import Button from './Button.js';
const FooterScrollToTop = ({
  useJavascriptScrollToTop = false,
  srLabel = 'Scroll to top'
}) => {
  const onClick = e => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    React.createElement(Button, {
      className: "ebds-footer__content__legal-row__scroll-to-top ebds-footer-link",
      type: "button",
      mode: "tertiary",
      state: "normal",
      href: useJavascriptScrollToTop ? '' : '#top',
      icon: /*#__PURE__*/React.createElement(IconAsChunk, {
        iconName: "UpDouble"
      }),
      srText: srLabel,
      onClick: e => useJavascriptScrollToTop ? onClick(e) : {}
    })
  );
};
export default /*#__PURE__*/memo(FooterScrollToTop);